import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { OutboundDeliveryResponse } from './common/outboundDeliveryResponse';

export interface AddOutboundDeliveryTransactionRequest {
  deliveryId: string;
  deliveryRowId: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  comment: string | null;
}

export interface AddOutboundDeliveryTransactionResponse {
  ok: true;
  delivery: OutboundDeliveryResponse;
}

export function useAddOutboundDeliveryTransactionApi() {
  return useCreateEntityApi<
    AddOutboundDeliveryTransactionRequest,
    AddOutboundDeliveryTransactionResponse
  >({
    url: 'delivery/outbound/transaction',
    translate: (t) => t.outboundDelivery.actions.transaction,
    async processOk(response) {
      const json = (await response.json()) as OutboundDeliveryResponse;
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
